export default "__VITE_ASSET__79d0bb6d__"